import classNames from 'classnames';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';

import { V4A_NAMESPACE } from '../constants';
import { Picture } from './picture';

/** The design's closing bar: logo, copyright, and the source of the rating quoted up the page. */
export function SiteFooter() {
  const { t } = useTranslation(V4A_NAMESPACE);
  const [failed, setFailed] = useState(false);
  return (
    <footer className='np-footer relative bg-[color:var(--np-black)] pb-[calc(var(--sp-10)_+_env(safe-area-inset-bottom,_0px))] pe-0 ps-0 pt-10'>
      <div className='np-footer__inner mx-auto flex max-w-[var(--container-wide)] flex-col items-start gap-3 px-[max(var(--gutter),_env(safe-area-inset-left,_0px),_env(safe-area-inset-right,_0px))] sm:flex-row sm:items-center sm:justify-between sm:gap-8'>
        <Link className={classNames('np-footer__logo -ms-2 inline-flex min-h-11 items-center rounded-[var(--r-sm)] px-2 py-0', failed && 'np-logo--text')} href='/' aria-label={t('header.home')}>
          <Picture name='logo' widths={[256, 512, 720]} fallbackWidth={512} sizes='(min-width: 64em) 120px, (min-width: 40em) 100px, 84px' alt='' width={720} height={166} loading='lazy' className='h-auto w-[84px] sm:w-[100px] lg:w-[120px]' onError={() => setFailed(true)} />
          <span className='np-logo-text items-center gap-[.3em] whitespace-nowrap text-[length:1.375rem] font-bold leading-none tracking-[-.03em] text-white forced-colors:text-[color:CanvasText]' aria-hidden='true'>
            noping
          </span>
        </Link>
        <p className='np-footer__copy text-[length:var(--fs-sm)] tracking-[.02em] text-[color:var(--fg-dim)]'>{t('footer.copyright', { year: new Date().getFullYear() })}</p>
      </div>
      <p className='np-rating-source mx-auto my-4 text-center text-[length:.72rem] opacity-65'>{t('footer.rating_source')}</p>
    </footer>
  );
}
